import React, { useContext, useEffect, useState } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';
import { Badge, Card, Col, message, Row, Statistic } from 'antd';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import Item from '../../components/Detail/Item';
import { Link } from 'react-router-dom';
import { WarningOutlined } from '@ant-design/icons';

const Detail = (props) => {
  const [loading, setLoading] = useState(true);
  const [vendor, setVendor] = useState({});
  const { id } = useContext(ParamsContext);

  useEffect(() => {
    fetchVendorDetail();
  }, [id]);

  const fetchVendorDetail = () => {
    setLoading(true);
    const url = `/vendor/detail?id=${id}`;
    axios.get(url).then(resp => {
      setVendor(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat detail perusahaan");
    });
  }

  return (
    <Auxiliary>
      <Title actions={(
        <Link to={`/vendor/update?id=${id}`} className="ant-btn">Perbarui Perusahaan</Link>
      )}>Detail Perusahaan</Title>
      {loading ? "Sedang memuat..." : (
        <Row>
          <Col span={14}>
            <Card className="gx-card">
              <Item label={`Nama Perusahaan`} value={vendor.name}/>
              <Item label={`Kode Perusahaan`} value={vendor.code}/>
              <Item label={`Kategori Perusahaan`} value={vendor.category.label}/>
              <Item label={`Jenis Perusahaan`} value={vendor.type.label}/>
              <Item label={`Divisi Perusahaan`} value={vendor.division.label}/>
              <Item label={`Email`} value={vendor.email}/>
              <Item label={`Nomor Telepon/WA`} value={vendor.phone}/>
            </Card>
          </Col>
          <Col span={10}>
            <Row>
              <Col span={12}>
                <Card className="gx-card gx-p-15">
                  <Statistic title="Personel Terdaftar" value={vendor.passport.total} />
                </Card>
              </Col>
              <Col span={12}>
                <Card className="gx-card gx-p-15">
                  <Statistic title="Total Tap" value={vendor.presence.all} />
                </Card>
              </Col>
              <Col span={12}>
                  <Card className="gx-card gx-p-15">
                    <Badge count={<WarningOutlined className="gx-text-danger" />} offset={[15,7]}>
                      <Statistic title="Request Pekerja" value={vendor.passport.request} />
                    </Badge>
                  </Card>  
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Auxiliary>
  );
}

export default Detail;